import { render, staticRenderFns } from "./bannerAdd.vue?vue&type=template&id=f7f95532&scoped=true"
import script from "./bannerAdd.vue?vue&type=script&lang=js"
export * from "./bannerAdd.vue?vue&type=script&lang=js"
import style0 from "./bannerAdd.vue?vue&type=style&index=0&id=f7f95532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f95532",
  null
  
)

export default component.exports